import EmailStatus from './EmailStatus'

export default EmailStatus
